// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ea785c7b","498":"9163e46b","703":"2ade2638","787":"420e9b08"}[chunkId] + ".chunk.js";
};